import { defineComponent as h, computed as l, openBlock as a, createElementBlock as i, createElementVNode as t, toDisplayString as f, createCommentVNode as d, normalizeStyle as n, createStaticVNode as p } from "vue";
const v = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "98b3a50d-ecfc-446f-b6bb-5093258fcac2" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), _ = { mask: "url(#98b3a50d-ecfc-446f-b6bb-5093258fcac2)" }, g = { key: 0 }, k = /* @__PURE__ */ p('<path fill="#0052b4" d="M256 0h256v512H0V256Z"></path><path fill="#eee" d="M0 0v32l32 32L0 96v160h32l32-32 32 32h32v-83l83 83h45l-8-16 8-15v-14l-83-83h83V96l-32-32 32-32V0H96L64 32 32 0Z"></path><path fill="#d80027" d="M32 0v32H0v64h32v160h64V96h160V32H96V0Zm96 128 128 128v-31l-97-97z"></path><path fill="#6da544" d="m320 144 48-80 48 80z"></path><circle cx="368" cy="144" r="48" fill="#acabb1"></circle><path fill="#338af3" d="M320 144v77c0 36 48 48 48 48s48-12 48-48v-77z"></path><rect width="32" height="128" x="288" y="128" fill="#ff9811" rx="16" ry="16"></rect><rect width="32" height="128" x="416" y="128" fill="#ff9811" rx="16" ry="16"></rect><path fill="#6da544" d="m368 160-48 67c2 11 9 19 16 26l32-45 32 45c8-7 14-15 16-26z"></path>', 9), u = { fill: "none" }, x = ["r"], V = /* @__PURE__ */ h({
  __name: "sh-ac",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const e = r, c = l(() => 512 + 2 * e.strokeWidth), o = l(() => -e.strokeWidth), s = l(() => 256 + e.strokeWidth / 2);
    return (b, y) => (a(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${o.value} ${o.value} ${c.value} ${c.value}`
    }, [
      m,
      t("g", _, [
        e.flagName ? (a(), i("title", g, f(e.flagName), 1)) : d("", !0),
        k
      ]),
      t("g", u, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: s.value,
          fill: "none",
          style: n({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, v));
  }
});
export {
  V as default
};
//# sourceMappingURL=sh-ac-593a57c6.js.map
